
'use strict';

export {
  productCustomizerConfig,
  productPreferencesConfig
}

function productCustomizerConfig (uiCustomizerConfigProvider) {
  'ngInject';

  // FeCon defaults
}


function productPreferencesConfig (iceApplicationPreferencesProvider) {
  'ngInject';

  let defaultPreferences = {
    "layouts.main.main-header.brand-logo.img": "assets/images/logo-infocert.png",
    "login-page.header.left-logo.href": "https://www.infocert.it/",
    "login-page.header.right-block.href": "http://help.infocert.it",
    "login-page.body.splash-img": "assets/images/skin-login/login-illustrazione.png",
    "login-page.form-box.logo.img": "assets/images/logo-legalmail.png",
    "features.main.guide": false

  };

  iceApplicationPreferencesProvider.setPreferences(defaultPreferences, false);
}




// WEBPACK FOOTER //
// ./client/app/app.config/customization.config.js